import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  Accordion,
  AccordionDetails,
  AccordionStack,
  AccordionSummary,
} from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { TENANT } from '../../../../tenant'
import { productAccessorGetSubstances } from '../../../model/productAccessor/productAccessorGetSubstances'
import { productAccessorIsRxOrOtxTemplate } from '../../../model/productAccessor/productAccessorIsRxOrOtxTemplate'
import { useProductPageContext } from '../../productPageContext'
import { ProductDescriptionDocumentLinks } from '../ProductDescriptionDocumentLinks'
import { ProductDescriptionIngredientsSection } from '../ProductDescriptionIngredients/ProductDescriptionIngredientsSection'
import { ProductDescriptionSection } from '../ProductDescriptionSection'
import { ProductDescriptionShowMore } from '../ProductDescriptionShowMore'
import { useProductDescriptionSections } from '../useProductDescriptionSections'

export const ProductDescriptionOldLayout: FC = () => {
  const { product, productTemplate } = useProductPageContext()
  const { tenant } = useGlobalConfigContext()
  const { additionalInformation, descriptionLong } =
    useProductDescriptionSections()
  const additionalInformationWithoutGeneralMarketingText =
    additionalInformation?.filter(
      (section, index) =>
        index > 0 || section.content !== product.general_marketing_text,
    ) ?? null
  const descriptionLongAndAdditionalInformation = [
    ...(descriptionLong ?? []),
    ...(additionalInformationWithoutGeneralMarketingText ?? []),
  ]
  const { activeSubstances, additiveSubstances } =
    productAccessorGetSubstances(product)
  const hasSubstances =
    activeSubstances.length > 0 || additiveSubstances.length > 0
  const shouldShowSubstancesSource = hasSubstances && tenant === TENANT.COM

  return (
    <>
      <ProductDescriptionDocumentLinks />
      <AccordionStack>
        {hasSubstances ? (
          <Accordion defaultExpanded>
            <AccordionSummary>
              <FormattedMessage id="productAdditonalInfos.label.activeIngredients" />
            </AccordionSummary>
            <AccordionDetails>
              {activeSubstances.length > 0 ? (
                <ProductDescriptionIngredientsSection
                  header={
                    <FormattedMessage id="productAdditonalInfos.headline.activeSubstances" />
                  }
                  substances={activeSubstances}
                />
              ) : null}
              {additiveSubstances.length > 0 ? (
                <ProductDescriptionIngredientsSection
                  header={
                    <FormattedMessage id="productAdditonalInfos.headline.additiveSubstances" />
                  }
                  substances={additiveSubstances}
                />
              ) : null}
              {shouldShowSubstancesSource ? (
                <p className="mb-3.5 text-s text-dark-primary-strong">
                  <FormattedMessage id="product.details.source.abda" />
                </p>
              ) : null}
            </AccordionDetails>
          </Accordion>
        ) : null}

        {descriptionLongAndAdditionalInformation.length > 0 ? (
          <Accordion defaultExpanded>
            <AccordionSummary>
              <FormattedMessage id="productAdditonalInfos.label.furtherProductInformation" />
            </AccordionSummary>
            <AccordionDetails>
              <ProductDescriptionShowMore
                defaultOpen={productAccessorIsRxOrOtxTemplate(productTemplate)}
              >
                {descriptionLongAndAdditionalInformation.map((section) => (
                  <ProductDescriptionSection
                    key={section.content}
                    section={section}
                  />
                ))}
              </ProductDescriptionShowMore>
            </AccordionDetails>
          </Accordion>
        ) : null}
      </AccordionStack>
    </>
  )
}
